<div class="tw-w-full tw-h-full tw-min-h-[100vh] tw-bg-background">
  <div class="tw-w-full tw-h-full tw-min-h-[100vh] tw-flex tw-flex-col tw-justify-center tw-items-center">
    <div class="max-md:tw-flex-1 tw-min-w-full tw-max-w-full md:tw-min-w-[600px] md:tw-max-w-[600px] tw-h-fit tw-bg-secondary md:tw-rounded-[10px] tw-p-4">
      <p class="tw-w-full tw-text-center tw-font-poppins tw-font-semibold tw-text-3xl md:tw-text-5xl tw-text-white tw-mb-5">404</p>
      <p class="tw-w-full tw-text-center tw-font-poppins tw-font-semibold tw-text-xl tw-text-white tw-mb-4">{{ "page-not-found-title" | translate }}</p>
      <p class="tw-w-full tw-text-center tw-font-poppins tw-font-normal tw-text-base tw-text-grey-300 tw-mb-10">{{ "page-not-found-message" | translate }}</p>
      <div class="tw-w-full tw-flex tw-justify-center tw-items-center">
        <button (click)="goToDiscover()" class="tw-w-fit tw-h-fit tw-bg-primary tw-font-poppins tw-font-semibold tw-text-sm tw-text-secondary tw-rounded-[5px] tw-px-6 tw-py-3">
          {{ "discover" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
